import {BehaviorSubject, Subject} from 'rxjs';
import {HPosition, VPosition} from '../types';

export type MessageOptions = {
	message: any;
} & NotificationOptions;

export type NotificationOptions = {
	vPos?: VPosition,
	hPos?: HPosition,
	timeToLive?: number,
	offsetX?: number,
	offsetY?: number
};

/**
 * Provide methods to manage Snackbar messages/layouts
 */
class SnackbarManagerImpl {
	public onMessage: Subject<MessageOptions> = new Subject<MessageOptions>();
	public onClear: Subject<void> = new Subject();
	public activeLayout: BehaviorSubject<string> = new BehaviorSubject<string>('');
	private layoutsStack: string[] = [];

	public setLayout(layout: string): void {
		if (this.activeLayout.value) {
			this.onClear.next();
		}
		this.layoutsStack.push(layout);
		this.activeLayout.next(layout);
	}

	public disposeLayout(layout: string): void {
		if (this.layoutsStack.includes(layout)) {
			this.layoutsStack = this.layoutsStack.filter(l => l !== layout);
		}
		const nextLayout = this.layoutsStack.pop();
		this.activeLayout.next(nextLayout);
	}

	/**
	 * @description adds message to topmost snackbar layout-deprecated. You can set the position via opts param. To set absolute position use opts.offsetX | opts.offsetY param
	 * @deprecated Use showSnackbarNotification function
	 * @param message - message to show
	 * @param opts - showing options
	 * @param {'top'|'center'|'bottom'} opts.vPos - vertical position (default:'bottom')
	 * @param {'left'|'center'|'right'} opts.hPos - horizontal position (default: 'left')
	 * @param {number} opts.timeToLive - how long will message be shown (default: 3000ms)
	 * @param {number} opts.offsetY - sets the offset to left
	 * @param {number} opts.offsetY - sets the offset to top
	 */
	public showSnackbar(message: string, opts: NotificationOptions = {}): void {

		if (!this.activeLayout.value) {
			return;
		}

		this.onMessage.next({
			message: message,
			vPos: opts.vPos || 'bottom',
			hPos: opts.hPos || 'left',
			timeToLive: opts.timeToLive || 3000,
			offsetX: opts.offsetX || 0,
			offsetY: opts.offsetY || 0,
		});
	}
}

export const SnackbarManager = new SnackbarManagerImpl();

/**
 * @description adds message to topmost snackbar layout-deprecated. You can set the position via opts param. To set absolute position use opts.offsetX | opts.offsetY param
 * @param message - message to show
 * @param opts - showing options
 * @param {'top'|'center'|'bottom'} opts.vPos - vertical position (default:'bottom')
 * @param {'left'|'center'|'right'} opts.hPos - horizontal position (default: 'left')
 * @param {number} opts.timeToLive - how long will message be shown (default: 3000ms)
 * @param {number} opts.offsetY - sets the offset to left
 * @param {number} opts.offsetY - sets the offset to top
 */
export function showSnackbarNotification(message: string, opts: NotificationOptions = {}): void {
	SnackbarManager.showSnackbar(message, opts);
}
